var app = angular.module('leonardo');

var DynamicFormDataRestService = function(BaseRestService, $q, $http, ConfigThemeService, RestangularProvider, NotificationService) {

  var service = new BaseRestService('dynamic-forms-data');

  var canceler_reports = $q.defer();

  service.getMimoReport = function(params) {
    return RestangularProvider.all('mimo').customGET('report', params);
  };

  service.getReports = function(params, noCancel) {
    if(!noCancel){
      canceler_reports.resolve();
      canceler_reports = $q.defer();
    }
    return RestangularProvider.all('dynamic-forms-data').withHttpConfig({timeout: canceler_reports.promise}).customPOST(params, 'report');
  };

  service.regeneratePdf = function(id) {
    return RestangularProvider.one('dynamic-forms-data', id).customPOST({}, 'regenerate-pdf');
  };

  return service;
};

app.factory('DynamicFormDataRestService', ['BaseRestService', '$q', '$http', 'ConfigThemeService', 'Restangular', 'NotificationService', DynamicFormDataRestService]);
